export default "__VITE_ASSET__Bp9ECtjH__"